import { render, staticRenderFns } from "./device-select.vue?vue&type=template&id=0a64345a&scoped=true&lang=pug&"
import script from "./device-select.vue?vue&type=script&lang=js&"
export * from "./device-select.vue?vue&type=script&lang=js&"
import style0 from "./device-select.vue?vue&type=style&index=0&id=0a64345a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64345a",
  null
  
)

/* custom blocks */
import block0 from "./device-select.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports